import {
    Modal, ModalOverlay, ModalContent, ModalHeader,
    ModalBody, ModalCloseButton, Button, Box, Text, Flex
} from "@chakra-ui/react";

export default function TemplatesModal({ isOpen, onClose, project }) {
    if (!project) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
            <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.800" />
            <ModalContent bg="#0f172a" color="white" borderRadius="2xl" border="1px solid #1e293b">
                <ModalHeader borderBottom="1px solid #1e293b" py={4}>
                    <Text fontSize="2xl" bgGradient="linear(to-r, #00e0ff, #007adf)" bgClip="text" fontWeight="bold">
                        {project.title}
                    </Text>
                </ModalHeader>
                <ModalCloseButton color="gray.400" />

                <ModalBody p={0}>
                    {/* Description Box */}
                    <Box p={6} bg="whiteAlpha.50">
                        <Text fontSize="lg" color="gray.300" lineHeight="tall">
                            {project.description}
                        </Text>
                    </Box>

                    {/* Browser Shell Mockup */}
                    <Box p={8}>
                        <Box
                            borderRadius="12px"
                            overflow="hidden"
                            boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.7)"
                            border="1px solid #334155"
                        >
                            {/* Browser Bar */}
                            <Flex bg="#1e293b" p={3} gap={2} align="center">
                                <Box w="10px" h="10px" borderRadius="full" bg="#ff5f56" />
                                <Box w="10px" h="10px" borderRadius="full" bg="#ffbd2e" />
                                <Box w="10px" h="10px" borderRadius="full" bg="#27c93f" />
                                <Box ml={4} bg="#0f172a" borderRadius="md" px={4} py={0.5} flex="1" fontSize="xs" color="gray.500">
                                    {project.link || "https://preview.yourdomain.com"}
                                </Box>
                            </Flex>

                            {/* Full Scrollable Website Image */}
                            <Box bg="#0f172a">
                                <img
                                    src={project.image}
                                    alt={project.title}
                                    style={{ width: "100%", height: "auto", display: "block" }}
                                />
                            </Box>
                        </Box>
                    </Box>
                </ModalBody>

                <Flex p={6} justify="space-between" align="center" borderTop="1px solid #1e293b">
                    <Button variant="ghost" color="gray.400" _hover={{bg: "whiteAlpha.100"}} onClick={onClose}>
                        Go Back
                    </Button>
                    <Button
                        as="a"
                        href={project.link}
                        target="_blank"
                        px={10}
                        bgGradient="linear(to-r, #00e0ff, #007adf)"
                        color="white"
                        _hover={{ opacity: 0.9, transform: 'translateY(-2px)' }}
                        transition="all 0.2s"
                    >
                        Visit Live Website
                    </Button>
                </Flex>
            </ModalContent>
        </Modal>
    );
}